import { ref } from "vue";
import { defineStore } from "pinia";
import { CountryCode } from "@/interfaces/countryCode";

export const useCountryCodesStore = defineStore("countryCodes", () => {
  const countryCodes = ref<CountryCode[]>([]);

  return {
    countryCodes,

    setCountryCodes(newCountryCodes: CountryCode[]) {
      countryCodes.value = newCountryCodes;
    },

    resetState() {
      countryCodes.value = [];
    },
  };
});
